<template>
  <div class="select-display">
    <div class="select">
      <span class="condition-name">{{ condition.name }}</span>
      <template v-if="condition.type === 'option'">
        <el-select
          v-if="condition.oneFlag"
          v-model="optionQuery.item"
          placeholder="请选择"
          class="content"
          clearable
          :class="{ 'required-hint': !result }"
        >
          <el-option
            v-for="item in itemOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          v-else
          v-model="optionQuery.items"
          multiple
          clearable
          placeholder="请选择"
          class="content"
          :class="{ 'required-hint': !result }"
        >
          <el-option
            v-for="item in itemOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </template>
      <user-selector
        v-else-if="condition.type === 'staff'"
        v-model="optionQuery.items"
        :multiple="!condition.oneFlag"
        clearable
        style="width: 200px"
        :class="{ 'required-hint': !result }"
      ></user-selector>
      <department-selector
        v-else-if="condition.type === 'department'"
        v-model="optionQuery.items"
        :include-sub="condition.defaultVal.value"
        clearable
        :multiple="!condition.oneFlag"
        from="query"
        style="width: 285px"
        :class="{ 'required-hint': !result }"
      ></department-selector>
      <company-selector
        v-else-if="condition.type === 'company'"
        v-model="optionQuery.items"
        clearable
        :multiple="!condition.oneFlag"
        style="width: 285px"
        :class="{ 'required-hint': !result }"
      ></company-selector>
      <address-selector
        v-else-if="condition.type === 'area'"
        v-model="optionQuery.items"
        :multiple="!condition.oneFlag"
        style="width: 285px"
        check-strictly
        size="mini"
        :class="{ 'required-hint': !result }"
      ></address-selector>
      <div v-else-if="condition.type === 'rate'" class="rate">
        <el-rate v-model="optionQuery.item" :colors="['#FF7373', '#FF7373', '#FF7373']"></el-rate>
        <i class="el-icon-circle-close clear" @click="clearStar"></i>
      </div>
    </div>
  </div>
</template>

<script>
import UserSelector from "@/components/FormControl/UserSelector"
import DepartmentSelector from "@/components/FormControl/DepartmentSelector"
import CompanySelector from "@/components/FormControl/CompanySelector"
import AddressSelector from "@/components/AddressSelector"
import department from "@/mixins/department"
export default {
  name: "selectDisplay",
  components: { AddressSelector, CompanySelector, DepartmentSelector, UserSelector },
  props: {
    condition: Object,
    controlOptionsMap: Object
  },
  mixins: [department],
  data() {
    return {
      optionQuery: {
        item: null,
        items: []
      },
      result: true,
      includeSubDepartment: false
    }
  },
  computed: {
    itemOptions() {
      let result = []
      if (!this._.isEmpty(this.controlOptionsMap)) {
        this.condition.charts.forEach(chart => {
          let options = this.controlOptionsMap[chart.controlId]
          result = result.concat(options)
        })
      }
      return this._.uniqBy(result, "value") || []
    }
  },
  watch: {
    condition: {
      handler() {
        this.initData()
      },
      deep: true,
      immediate: true
    },
    optionQuery: {
      handler() {
        this.$emit("getVerifyResult")
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.$on("department-status-change", t => {
      this.includeSubDepartment = t
    })
  },
  methods: {
    initData() {
      if (this.condition.type === "option") {
        this.condition.oneFlag
          ? (this.optionQuery.item = this.condition.defaultVal?.value)
          : (this.optionQuery.items = this.condition.defaultVal?.values)
      } else if (this.condition.type === "rate") {
        this.optionQuery.item = this.condition.defaultVal?.value
      } else {
        this.optionQuery.items = this.condition.defaultVal?.values
        if (this.condition.type === "department")
          this.includeSubDepartment = this.condition.defaultVal?.value
      }
    },
    async getOptionFilters(chart) {
      if (this.optionQuery.item || !this._.isEmpty(this.optionQuery.items)) {
        let filter = {}
        filter.compareMethod =
          this.condition.type === "rate"
            ? "等于"
            : this.condition.type === "area"
            ? "在...中"
            : "包含"
        filter.key = chart.controlId
        filter.type = this.condition.type
        filter.value = null
        if (this.condition.type === "option") {
          if (this.condition.oneFlag) {
            filter.varItems = [{ value: this.optionQuery.item, var: false }]
          } else {
            filter.varItems = this.optionQuery.items.map(item => ({ value: item, var: false }))
          }
        } else if (this.condition.type === "rate") {
          filter.varItems = [{ value: this.optionQuery.item, var: false }]
        } else if (this.condition.type === "area") {
          filter.varItems = this.optionQuery.items.map(item => ({ value: item[0], var: false }))
        } else {
          let value = this.optionQuery.items.map(item => ({ value: item, var: false }))
          if (this.condition.type === "department" && this.includeSubDepartment) {
            await this.initPromise
            value = this.getFilterDepartmentIds(value)
          }
          filter.varItems = value
        }
        return [filter]
      } else {
        return []
      }
    },
    getVerify() {
      let result = true
      if (this.condition.type === "option") {
        if (this.condition.oneFlag) {
          if (this._.isEmpty(this.optionQuery.item)) result = false
        } else {
          if (this._.isEmpty(this.optionQuery.items)) result = false
        }
      } else if (this.condition.type === "rate") {
        if (this._.isEmpty(this.optionQuery.item)) result = false
      } else {
        if (this._.isEmpty(this.optionQuery.items)) result = false
      }
      this.result = result
      return result
    },
    clearStar() {
      this.optionQuery.item = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.select-display {
  .select {
    display: flex;
    align-items: center;
    .condition-name {
      margin-right: 10px;
      white-space: nowrap;
    }
    .rate {
      display: flex;
      align-items: center;
      &:hover {
        .clear {
          visibility: visible;
        }
      }
      .clear {
        font-size: 16px;
        color: rgb(198, 209, 222);
        visibility: hidden;
        cursor: pointer;
      }
    }
  }

  .required-hint {
    ::v-deep {
      .el-input__inner {
        border-color: #f56c6c;
      }
      .container {
        border-color: #f56c6c;
      }
    }
  }
}
</style>
